import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LayoutComponent } from './app-components/layout/layout.component'
export const routes: Routes = [
    {
        path: '',
        component: LayoutComponent,
        children: [
            { path: '', loadChildren: './modulos/inicio/inicio.module#InicioModule' },
            { path: 'legislacion', loadChildren: './modulos/legislacion/legislacion.module#LegislacionModule' },
            { path: 'institucional', loadChildren: './modulos/institucional/institucional.module#InstitucionalModule' },
            { path: 'difusion', loadChildren: './modulos/difusion/difusion.module#DifusionModule' },
            { path: 'contacto', loadChildren: './modulos/contacto/contacto.module#ContactoModule' },
            { path: 'diputados', loadChildren: './modulos/diputados/diputados.module#DiputadosModule' },
            { path: 'agenda', loadChildren: './modulos/agenda/agenda.module#AgendaModule' },
            { path: 'gaceta', loadChildren: './modulos/gaceta-parlamentaria/gaceta-parlamentaria.module#GacetaParlamentariaModule' },
            { path: 'orden-dia', loadChildren: './modulos/orden-dia/orden-dia.module#OrdenDiaModule' },
            { path: 'pagina', loadChildren: './modulos/plantillas/plantillas.module#PlantillasModule' },
            { path: 'infomaya', loadChildren: './modulos/infomaya/infomaya.module#InfomayaModule' },
        ]
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full'
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {useHash:true})],
    exports: [RouterModule]
})

export class AppRoutingModule { }
